import { useFilterShiftTypeContext } from "./filter-shift-type.context";

export function FilterShiftType() {
  const { dateFilterElement, reportFilterElements, clearFiltersElement } =
    useFilterShiftTypeContext();

  return (
    <div>
      <h2>Filters</h2>
      <p className="mb-4">
        Select the following filters you want to apply to the current table.
      </p>

      {dateFilterElement}
      {reportFilterElements}
      {clearFiltersElement}
    </div>
  );
}